import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AuthModalWidget from '../components/AuthModalWidget';

const RegisterPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const referralCode = searchParams.get('ref');

  useEffect(() => {
    // If user is already authenticated, redirect to home
    if (isAuthenticated) {
      navigate('/');
      return;
    }

    // Open the modal automatically when the page loads with a small delay
    // to ensure the page is fully rendered
    const timer = setTimeout(() => {
      setIsModalOpen(true);
    }, 100);

    return () => clearTimeout(timer);
  }, [isAuthenticated, navigate]);

  const handleClose = () => {
    setIsModalOpen(false);
    // Redirect to home after closing modal
    setTimeout(() => {
      navigate('/');
    }, 300); // Small delay to allow modal close animation
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <AuthModalWidget
        isOpen={isModalOpen}
        onClose={handleClose}
        onHideForWalletConnect={() => setIsModalOpen(false)}
        onWalletConnected={() => setIsModalOpen(true)}
        initialMode="signup"
        referralCode={referralCode}
      />
    </div>
  );
};

export default RegisterPage;

